(function (angular) {
	'use strict';

	angular
		.module('viewPlanModule', [
			'apiModule',
			'coreModule',
			'hypotheticalPerformanceModule',
			'optionsModule',
			'orderFormModule',
			'planModule',
			'portfolioAllocationChartModule',
			'reitElementListingModule',
			'questionnaireModule',
			'riskAdjustedReturnModule',
			'serviceLevelModule',
			'topQuestionsModule'
		])
		.value('globalConfig', globalConfig);
})(window.angular);